import './style.scss';

import { IonButton, IonSlide, IonSlides } from '@ionic/react';
import { useInject } from 'inversify-hooks';
import * as React from 'react';
import { useHistory } from 'react-router';
import FullscreenLayout from 'ui/layout/FullscreenLayout';
import { useContextTranslation } from 'ui/translation';

import injectables from '../../services/injectables';
import type IOnboardingService from '../../services/IOnboardingService';

const SLIDER_OPTIONS = {
  touchReleaseOnEdges: true,
  longSwipes: false,
};

const OnboardingPage: React.FC = () => {
  const slidesRef = React.useRef<HTMLIonSlidesElement>(null);
  const t = useContextTranslation('page.onboarding');
  const history = useHistory();
  const [service] = useInject<IOnboardingService>(
    injectables.OnboardingService,
  );

  const onNextClick = () => {
    slidesRef.current?.slideNext();
  };

  const onFinish = () => {
    service.setOnboardingViewed().finally(() => {
      history.replace('/home', { direction: 'forward' });
    });
  };

  return (
    <FullscreenLayout>
      <IonSlides
        options={SLIDER_OPTIONS}
        ref={slidesRef}
        className="onboarding-slider"
        pager
      >
        <IonSlide className="slide step-1">
          <div className="logo" />
          <div className="content bottom">
            <h2>{t('step1.title')}</h2>
            <p>{t('step1.subtitle')}</p>
          </div>
          <IonButton
            onClick={onNextClick}
            expand="block"
            shape="round"
            color="primary"
          >
            {t('step1.button')}
          </IonButton>
        </IonSlide>
        <IonSlide className="slide step-2">
          <div className="content">
            <h2>{t('step2.title')}</h2>
            <p>{t('step2.subtitle')}</p>
          </div>
          <IonButton
            onClick={onNextClick}
            expand="block"
            shape="round"
            color="primary"
          >
            {t('step2.button')}
          </IonButton>
        </IonSlide>
        <IonSlide className="slide step-3">
          <div className="content">
            <h2>{t('step3.title')}</h2>
            <p>{t('step3.subtitle')}</p>
          </div>
          <IonButton
            onClick={onFinish}
            expand="block"
            shape="round"
            color="primary"
          >
            {t('step3.button')}
          </IonButton>
        </IonSlide>
      </IonSlides>
    </FullscreenLayout>
  );
};

export default OnboardingPage;
